import numeral from 'numeral';

export default [
    {
        renderCell: ({ item }) => {
            let type = item.type.replace(/_/g, ' ');
            type = type[0].toUpperCase() + type.slice(1).toLowerCase();

            return (
                <div className="col-12 ms-3">
                    <a
                        href={
                            `/domains/${window.info.id}/entities/entity?entities:in=` +
                            encodeURIComponent(item.name)
                        }
                    >
                        {item.name} ({type})
                    </a>
                </div>
            );
        },
        label: 'Celebrity',
    },
    {
        key: 'impressions',
        label: 'Impressions',
        className: 'list-data-secondary-text',
        renderCell: ({ data }) => numeral(data).format('0.0a'),
    },
    {
        renderCell: ({ item, allData }) => {
            const max = getMax(allData);
            const percent = item.impressions / max;
            return percent * 100;
        },
        label: 'Rank',
        bar: true,
        key: 'rank',
    },
];

function getMax(data) {
    return data?.reduce((acc, curr) => {
        if (curr.impressions > acc) acc = curr.impressions;
        return acc;
    }, 0);
}
